var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaleActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0756 54 0 41.9064 0 27C0 12.0756 12.0936 0 27 0C41.9243 0 54 12.0936 54 27C54.0179 41.9243 41.9243 54 27 54Z",
    fill: "#B5E2DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8165_25519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0756 54 0 41.9064 0 27C0 12.0756 12.0936 0 27 0C41.9243 0 54 12.0936 54 27C54.0179 41.9243 41.9243 54 27 54Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8165_25519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1203 49.7351C41.9943 49.8251 41.8503 49.9151 41.7243 50.0051C41.5803 50.0951 41.4543 50.1851 41.3103 50.2571C41.1843 50.3291 41.0763 50.4011 40.9503 50.4731C40.9323 50.4911 40.9143 50.4911 40.8963 50.5091C40.4823 50.7611 40.0503 50.9951 39.6183 51.2111C39.4923 51.2831 39.3483 51.3551 39.2223 51.4091C39.2223 51.4091 39.2043 51.4271 39.1863 51.4271C39.0423 51.4991 38.8983 51.5711 38.7543 51.6431C38.4663 51.7871 38.1603 51.9131 37.8723 52.0391C37.7283 52.1111 37.5663 52.1651 37.4223 52.2191C37.2783 52.2731 37.1163 52.3451 36.9723 52.3991C36.8283 52.4531 36.6663 52.5251 36.5223 52.5791C36.5223 52.5791 36.5223 52.5791 36.5043 52.5791C36.3603 52.6331 36.1983 52.6871 36.0543 52.7411C35.7303 52.8491 35.3883 52.9571 35.0643 53.0651C34.9563 53.1011 34.8303 53.1371 34.7223 53.1731C34.3803 53.2811 34.0383 53.3711 33.6963 53.4431C33.5703 53.4791 33.4443 53.4971 33.3003 53.5331C32.9763 53.6051 32.6343 53.6771 32.3103 53.7491C32.2383 53.7671 32.1843 53.7671 32.1123 53.7851C32.0043 53.8031 31.8783 53.8211 31.7703 53.8391C31.6083 53.8571 31.4643 53.8931 31.3023 53.9111C31.2303 53.9291 31.1583 53.9291 31.0863 53.9471C30.9963 53.9651 30.8883 53.9831 30.7803 53.9831C30.4923 54.0191 30.1863 54.0551 29.8983 54.0911C29.8083 54.1091 29.7003 54.1091 29.6103 54.1271H29.5923C29.4663 54.1451 29.3403 54.1451 29.2143 54.1631C29.0883 54.1811 28.9623 54.1811 28.8363 54.1811C28.7643 54.1811 28.6743 54.1991 28.6023 54.1991C28.4583 54.1991 28.3323 54.2171 28.2063 54.2171C28.0263 54.2171 27.8643 54.2351 27.6843 54.2351C27.5043 54.2351 27.3423 54.2351 27.1623 54.2351C27.0363 54.2351 26.9103 54.2351 26.7843 54.2351C19.2063 54.1271 12.3663 50.9051 7.50628 45.7931C7.50628 45.7931 7.50628 45.7751 7.48828 45.7751C8.04628 44.6771 10.1163 42.6971 12.2763 41.0591C15.0123 38.9891 18.8823 37.7111 18.8823 37.7111C18.8823 37.7111 21.4203 37.2971 30.8343 39.2591C38.0163 40.7711 41.0763 46.9091 42.1203 49.7351Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8324 44.2451C32.4544 46.0991 30.0064 47.1971 25.8844 45.5411C20.8264 43.4891 18.8824 37.7111 18.8824 37.7111C18.6124 33.5711 17.9824 30.0251 17.9824 30.0251C23.8324 29.5211 30.7444 36.3611 30.7444 36.3611L31.5364 39.7451C31.6084 40.0331 31.7524 40.2851 31.9684 40.4651C32.3464 41.1131 33.0844 43.0571 32.8324 44.2451Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9674 40.4831C28.5294 40.3031 25.9914 39.7991 23.2734 34.9211C25.5774 36.9551 28.2954 37.7291 31.1574 38.0891L31.5354 39.7451C31.6074 40.0511 31.7514 40.3031 31.9674 40.4831Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0782 18.7931C39.4022 20.3051 39.5642 21.5291 38.6822 25.5611C37.8002 29.5931 39.4922 33.6251 35.2442 37.3151C32.3822 39.7991 27.3783 40.2671 23.3823 37.5491C22.0323 36.6311 20.7903 35.3531 19.7823 33.6791C18.9903 32.3651 18.0723 31.1231 17.0463 29.9891C15.6243 28.4411 13.9143 25.3271 14.7603 19.8191C16.1283 10.8551 25.0023 9.82914 30.2402 10.8191C35.4782 11.8091 38.1962 14.7971 39.0782 18.7931Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8528 25.8311C21.8528 25.8311 21.2948 23.1311 18.6668 23.4551C16.3988 23.7431 15.6068 29.1791 20.7548 30.6911",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5928 28.2251C20.5928 28.2251 19.9448 27.8111 20.0168 27.0911C20.1248 26.2451 20.0168 25.7231 19.6208 25.5611C18.6308 25.1471 18.4328 26.2991 18.4688 26.4431",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3262 29.9711C34.3262 29.9711 35.0102 30.0071 35.6582 29.2331C36.0182 28.8011 36.3242 28.2611 36.1262 28.0991C35.9282 27.9191 32.6702 28.4231 32.4542 28.8551C32.2382 29.2871 33.4982 29.9711 34.3262 29.9711Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8665 23.9231C34.8665 23.9231 34.9025 25.6331 36.0005 27.5411C36.4865 28.3871 35.7485 29.7731 34.1465 30.0071",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M25.1099 30.8891C26.1338 30.8891 26.9639 30.2041 26.9639 29.3591C26.9639 28.5141 26.1338 27.8291 25.1099 27.8291C24.0859 27.8291 23.2559 28.5141 23.2559 29.3591C23.2559 30.2041 24.0859 30.8891 25.1099 30.8891Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M38.394 27.8651C38.34 28.8731 38.358 29.8631 38.286 30.8531C37.494 30.6731 36.918 30.0791 36.918 29.3771C36.918 28.6211 37.548 28.0091 38.394 27.8651Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.941 46.3819C41.385 43.0879 37.425 41.7199 35.247 40.9099C35.067 40.0099 34.725 39.0199 34.185 38.0659C33.357 38.5699 32.403 38.9479 31.413 39.1459L31.557 39.7399C31.629 40.0279 31.989 41.3599 31.431 43.0699C30.963 44.5099 29.073 45.1579 25.869 43.6999C19.623 40.8739 18.903 37.6879 18.903 37.6879C18.795 35.9599 18.615 34.3399 18.453 33.0259C16.509 33.4579 14.259 34.3399 13.035 36.1939C11.523 38.4619 10.965 40.7659 11.109 42.6019C8.48104 44.2759 4.41305 46.8139 3.08105 51.3499C1.35305 57.2539 1.64105 60.8719 1.64105 60.8719H48.153C48.099 60.8899 47.415 50.8639 43.941 46.3819Z",
    fill: "#6060D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1309 40.4779C16.1309 40.4779 17.2289 44.7439 22.0349 47.6959",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2288 40.9099C35.2288 40.9099 36.5068 46.4359 33.7168 48.9739",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5532 48.1279C26.5532 48.1279 25.6172 50.8639 25.8692 52.7539",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2949 47.9659C32.2949 47.9659 32.9969 49.4959 33.5009 51.9259",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0723 42.6199C11.0723 42.6199 12.5483 48.6319 21.3323 50.3959",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0316 53.1679L25.2396 53.0959C24.9516 53.0599 24.7356 52.7899 24.7896 52.5019L25.0596 51.1519C25.1316 50.7739 25.4916 50.5039 25.8696 50.5579C26.2476 50.5939 26.5536 50.9179 26.5536 51.3139L26.5716 52.6999C26.5716 52.9699 26.3196 53.2039 26.0316 53.1679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2925 52.3399L33.5365 52.6099C33.2485 52.7179 32.9425 52.5379 32.8885 52.2499L32.5645 50.9179C32.4745 50.5399 32.6725 50.1619 33.0505 50.0179C33.4105 49.8919 33.8245 50.0539 33.9865 50.3959L34.5805 51.6379C34.7065 51.9079 34.5805 52.2319 34.2925 52.3399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2305 51.9259C42.2305 51.9259 43.2385 57.5779 42.8425 60.8899",
    stroke: "#544D4D",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4083 25.7304C27.9763 25.7124 27.6523 25.3524 27.6883 24.9204L27.7063 24.4164C27.7243 23.9844 28.0843 23.6604 28.5163 23.6964C28.9483 23.7144 29.2723 24.0744 29.2363 24.5064L29.2183 25.0104C29.2003 25.4244 28.8403 25.7484 28.4083 25.7304Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9875 26.0004C35.5915 25.9824 35.2855 25.6404 35.3035 25.2444L35.3215 24.7764C35.3395 24.3804 35.6815 24.0744 36.0775 24.0924C36.4735 24.1104 36.7795 24.4524 36.7615 24.8484L36.7435 25.3164C36.7255 25.7124 36.3835 26.0184 35.9875 26.0004Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1552 24.6864C30.1552 24.6864 29.6872 24.0204 28.8772 23.8944C28.2112 23.7864 27.4732 24.1104 27.3652 24.4884",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4648 24.8484C35.4648 24.8484 35.4648 24.2724 36.2928 24.2724C36.9768 24.2724 37.2648 24.9024 37.2648 24.9024",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8926 21.7884C31.2706 21.9144 31.6486 21.5724 31.5766 21.1584C31.5406 20.9424 31.4506 20.7264 31.2706 20.5644C30.7306 20.0784 28.4986 19.6464 27.1486 20.2764C25.9606 20.8524 29.1646 21.2124 30.8926 21.7884Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2753 22.0764C35.9693 22.1844 35.6453 21.8604 35.6993 21.4824C35.7173 21.2844 35.7893 21.0864 35.9333 20.9424C36.3653 20.5104 37.8413 20.1684 38.7773 20.8344C39.5873 21.3924 37.6793 21.5544 36.2753 22.0764Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0183 32.4919C35.0432 32.89 34.7445 33.5868 34.1971 34.0844C31.3853 32.3675 30.1162 33.2633 30.1162 33.2633C29.1209 31.7454 29.3448 29.68 31.7585 31.2477C33.4506 32.3177 34.4708 32.4919 35.0183 32.4919Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1961 34.0844C33.5989 34.607 32.7031 34.9305 31.4838 34.4328C30.9115 34.2089 30.4636 33.7609 30.1152 33.2633C30.1152 33.2633 31.3843 32.3675 34.1961 34.0844Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4915 32.3924C35.4915 32.3924 34.4464 32.9647 31.759 31.2477C28.549 29.1824 29.1959 33.5121 31.4603 34.4328C33.8243 35.4033 35.0436 33.2882 35.0187 32.4919",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1152 33.2633C30.1152 33.2633 31.3843 32.3675 34.1961 34.0844",
    stroke: "#423232",
    strokeWidth: 0.746506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4679 14.4481C39.1899 19.0741 35.4819 18.3001 32.0079 17.0401C27.3819 15.3481 23.3139 16.7161 23.2959 20.8921C23.2599 27.0121 21.7299 25.1581 21.5679 24.9241C21.1719 24.1681 20.3259 23.2321 18.7239 23.4301C16.6179 23.7001 15.7899 28.3441 19.7139 30.2521C20.3979 33.7261 18.5259 33.4021 18.5259 33.4021C17.8959 30.8461 12.6039 25.4101 12.5859 21.8281C12.5859 17.0041 15.0159 15.6361 15.0159 15.6361C15.0879 12.2701 18.5979 8.56214 24.5019 8.68814C30.4059 8.79614 34.0239 8.63414 35.1759 7.24814C36.3279 5.82615 41.7459 9.82214 40.4679 14.4481Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6124 20.0101C40.4324 21.1801 39.9284 22.0801 39.2264 22.7461C39.4964 20.7841 39.3524 19.8481 39.1184 18.7501C38.6144 16.5001 37.5344 14.5561 35.7344 13.1161C36.6344 13.0441 37.5524 13.2421 38.3804 13.7641C38.3804 13.7461 41.3504 14.9521 40.6124 20.0101Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8202 26.4236C19.8202 26.4236 18.3802 26.2076 18.4882 28.2236C18.5422 29.2496 18.5422 29.8076 18.5242 30.0956C18.5062 30.2936 18.6322 30.4736 18.8122 30.5456C19.0282 30.6356 19.2622 30.5456 19.3702 30.3296C19.5322 30.0416 19.7122 29.6456 19.7122 29.3216C19.7122 28.7816 20.2882 28.2956 20.2882 28.2956C20.2882 28.2956 19.7662 27.8456 19.8202 26.4236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1758 61.1276C24.0318 60.9656 18.3798 51.2996 19.2258 47.6636C19.8018 45.1616 19.0458 42.2816 18.3798 39.7436C18.1098 38.6996 17.8578 37.7276 17.7138 36.8636C17.4618 35.3696 17.6418 33.9476 18.2538 32.6336C18.9198 31.1576 18.8118 29.8796 18.8118 29.8616L19.1718 29.8256C19.1718 29.8796 19.2798 31.2296 18.5778 32.7776C18.0018 34.0196 17.8398 35.3876 18.0738 36.8096C18.2178 37.6556 18.4698 38.6276 18.7398 39.6716C19.4238 42.2456 20.1798 45.1796 19.5858 47.7716C18.7938 51.2276 24.4278 60.8936 24.4638 60.9296L24.1758 61.1276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5427 29.2675C18.5607 29.6635 18.5427 29.9335 18.5427 30.0955C18.5247 30.2935 18.6507 30.4735 18.8307 30.5455C19.0467 30.6355 19.2807 30.5455 19.3887 30.3295C19.5507 30.0415 19.7307 29.6455 19.7307 29.3215C19.7307 29.3035 19.7307 29.2675 19.7307 29.2495C19.3527 29.3935 18.9207 29.5015 18.5427 29.2675Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4801 41.2376C35.3541 42.0656 35.3361 43.3795 35.3001 44.9095C35.2461 47.8615 33.5001 59.3635 32.6541 61.1815L32.3301 61.0375C33.1401 59.2735 34.8861 47.8255 34.9401 44.9095C34.9761 43.3795 34.9941 42.0475 35.1201 41.1835C35.3901 39.3655 35.1921 37.9976 35.0841 37.4216C35.1381 37.3676 35.1921 37.3316 35.2461 37.2776C35.3001 37.2416 35.3361 37.1876 35.3901 37.1516C35.4981 37.6196 35.8041 39.1136 35.4801 41.2376Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleActive);
export default __webpack_public_path__ + "static/media/male-active.dcf30b0624b7ef19260fd2bb31fb89bb.svg";
export { ForwardRef as ReactComponent };